import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Autocomplete } from 'Components/ui';

const INK = 'var(--vo-ink)';
const MUTED = 'var(--vo-slate)';

const Card = styled.div`
  max-width: 800px;
  background: white;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const SectionHead = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
`;
const IconTile = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const SectionTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${INK};
  margin: 0 0 2px;
`;
const SectionSub = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
  margin: 0;
`;

const FieldsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const FieldLabel = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: ${MUTED};
`;

const isSameRecord = (option, val) => option._id === val._id;

export const Vinculos = ({ control, processes, systems, assets, processLoading, systemLoading, assetLoading, t }) => (
  <Card>
    <SectionHead>
      <IconTile>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
        </svg>
      </IconTile>
      <div>
        <SectionTitle>{t('asm:areas.form.bondsSectionTitle')}</SectionTitle>
        <SectionSub>{t('asm:areas.form.bondsSectionSubtitle')}</SectionSub>
      </div>
    </SectionHead>

    <FieldsStack>
      <FieldGroup>
        <FieldLabel>{t('asm:areas.form.bonds.processes')}</FieldLabel>
        <Controller
          control={control}
          name="processes"
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              multiple
              filterSelectedOptions
              isOptionEqualToValue={isSameRecord}
              options={(processes || []).filter(item => !item.archived)}
              getOptionLabel={(item) => item.name}
              value={value || []}
              onChange={onChange}
              loading={processLoading}
              disabled={processLoading}
              placeholder={t('asm:areas.form.bonds.searchProcess')}
            />
          )}
        />
      </FieldGroup>

      <FieldGroup>
        <FieldLabel>{t('asm:areas.form.bonds.systems')}</FieldLabel>
        <Controller
          control={control}
          name="systems"
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              multiple
              filterSelectedOptions
              isOptionEqualToValue={isSameRecord}
              options={(systems || []).filter(item => !item.archived)}
              getOptionLabel={(item) => item.name}
              value={value || []}
              onChange={onChange}
              loading={systemLoading}
              disabled={systemLoading}
              placeholder={t('asm:areas.form.bonds.searchSystem')}
            />
          )}
        />
      </FieldGroup>

      <FieldGroup>
        <FieldLabel>{t('asm:areas.form.bonds.assets')}</FieldLabel>
        <Controller
          control={control}
          name="assets"
          render={({ field: { onChange, value } }) => (
            <Autocomplete
              multiple
              filterSelectedOptions
              isOptionEqualToValue={isSameRecord}
              options={(assets || []).filter(item => !item.archived)}
              getOptionLabel={(item) => item.name}
              value={value || []}
              onChange={onChange}
              loading={assetLoading}
              disabled={assetLoading}
              placeholder={t('asm:areas.form.bonds.searchAsset')}
            />
          )}
        />
      </FieldGroup>
    </FieldsStack>
  </Card>
);
